import type { Point } from "./geometry";

type Line = Array<Point>;

export function appendInstructions(path: string, line: Line) {
  if (line.length < 1) {
    return path;
  }

  return line.reduce((next, item, i) => {
    return `${next} ${i == 0 ? "M" : "L"} ${item.x}, ${item.y}`;
  }, path);
}

export function appendPair(path: string, a: Point, b: Point) {
  return `${path} M ${a.x}, ${a.y} L ${b.x}, ${b.y}`;
}

export function linePath(line: Line) {
  return appendInstructions("", line);
}
